'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _configStorage = require('./internal/config-storage');

var _configStorage2 = _interopRequireDefault(_configStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _configStorage2.default)({});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/components.js
// module id = 472
// module chunks = 0